// extracted by mini-css-extract-plugin
module.exports = {"languageSelection":"language-selection_languageSelection__OVow2","active":"language-selection_active__2PamK"};